<h1 mat-dialog-title>Add Members</h1>
<div mat-dialog-content>
  <mat-form-field style="width: 20rem;">
    <mat-select placeholder="Select Members" [(ngModel)]="selectedMembers" multiple>
      @for (member of data.members; track member) {
        <mat-option [value]="member">{{ member.email }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close(false)">Cancel</button>
  <button mat-button [mat-dialog-close]="selectedMembers" (click)="saveTeam()">Save</button>
</div>